import React, {useCallback} from "react";
import PropTypes, {InferProps} from "prop-types";
import {File} from "@betrue/shared/interfaces";
import {FileLinkView} from "./file-link.view";
import {useFile} from "@betrue/front/services";

export const FileLinkPropsTypes = {
  deleteLabel: PropTypes.string,

}
export type FileLinkProps = InferProps<typeof FileLinkPropsTypes>

export interface FileLinkInternalProps extends FileLinkProps {
  file: File,
  removable: boolean
}

export const FileLink = (props: FileLinkInternalProps) => {
  const [file, {deleteFile}] = useFile(props.file)
  const handleOnDelete = useCallback((file: File) => {
    deleteFile(file.id)
  }, [file])

  if (!file || file.removed) return (<>Aucun fichier</>)

  return (
    <FileLinkView removable={props.removable} {...props.file} file={file} onDelete={handleOnDelete}/>
  );
}


FileLink.propTypes = FileLinkPropsTypes
